/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.production = process.env.PRODUCTION || "false";
config.sitecoreApiHost = process.env.SITECORE_API_HOST || "https://www.eurobankequities.gr";
config.sitecoreApiKey = process.env.SITECORE_API_KEY || "{40D54338-B819-42F3-8C9D-114AE2C043BF}";
config.sitecoreSiteName = process.env.SITECORE_SITE_NAME || "eurobankequities";
config.sitecoreLayoutServiceConfig = process.env.SITECORE_LAYOUT_SERVICE_CONFIG || "jss";
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || "en";
config.defaultServerRoute = process.env.DEFAULT_SERVER_ROUTE || "/";
config.layoutServiceConfigurationName = process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || "jss";
config.urlOrigin = process.env.URL_ORIGIN || "https://www.eurobankequities.gr";
config.assetsUrl = process.env.ASSETS_URL || "/dist/eurobankequities/browser/assets/";
config.recaptchaSiteKey = process.env.RECAPTCHA_SITE_KEY || "6LdtMVQrAAAAAFIeY4QFcrvp7UkbGuCFJiw4vMSJ";
config.cookieDomain = process.env.COOKIE_DOMAIN || "a8617edb-871d-42fa-875b-b51a669e445c";
config.searchApiHost = process.env.SEARCH_API_HOST || "https://eurobank-prod.rfk.eurobank.gr/api/discover/v2";
config.searchDomainId = process.env.SEARCH_DOMAIN_ID || "2117074929";
config.searchApiKey = process.env.SEARCH_API_KEY || "01-457dcec1-1ca876c4d1c37c8980d6b724e57f320e70a0d2cb";
config.searchApiSource = process.env.SEARCH_API_SOURCE || "1140992";
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge";
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports.environment = config;